import React, { useState } from 'react'
import { useStore } from 'src/state'
import Page from 'src/components/page'
import Container from 'src/components/container'
import ProductCard from 'src/components/product-card'
import CardGrid from 'src/components/card-grid'
import Button from 'src/components/button'
import Picture from 'src/components/picture'

const CollectionDetail = ({ pageContext: { collection } }) => {
  const defaultMaxCards = 6
  const {
    general: { loadMoreProductsText },
  } = useStore()
  const { title } = collection
  const [maxCards, setMaxCards] = useState(defaultMaxCards)
  const hasMoreCards = collection.products.length > maxCards
  return (
    <Page className="page-collection-detail">
      <Container>
        <div className="collection-hero">
          <h1 className="collection-title centered">{title}</h1>
          {collection.metafields.heroDescription && (
            <p className="collection-description centered">
              {collection.metafields.heroDescription}
            </p>
          )}
          {collection.metafields.partnerDescription && (
            <h3 className="partner-description centered size-medium">
              {collection.metafields.partnerDescription}
            </h3>
          )}
          {collection.metafields.partnerLogo && (
            <Picture
              className="partner-logo centered"
              image={collection.metafields.partnerLogo}
              fitWidth
              contain
            />
          )}
        </div>
        <CardGrid className="products" maxCards={maxCards}>
          {collection.products.map((product) => (
            <ProductCard key={product.id} {...product} />
          ))}
        </CardGrid>
        {hasMoreCards && (
          <Button
            className="load-more-btn centered"
            onClick={() => setMaxCards(maxCards + defaultMaxCards)}
          >
            <span className="action-text size-big">{loadMoreProductsText}</span>
          </Button>
        )}
      </Container>
    </Page>
  )
}

export default CollectionDetail
